import {Typography} from "@mui/material";
import React from "react";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => <>
    <Typography component="p">
        All Parent suppliers that have at least <b>two</b> suppliers are considered Parent suppliers.
    </Typography>
</>
